function d() {
  var e, n;
  return typeof window == "undefined" || !window.dataLayer ? "" : (n = (e = window.dataLayer.find(a => a.page)) == null ? void 0 : e.page) == null ? void 0 : n.pageType;
}
export { d as getObjectName };